export const isNewSwVersion = (
  checkVersion: string,
  currentVersion: string,
) => {
  return (
    checkVersion.localeCompare(currentVersion, undefined, { numeric: true }) ===
    1
  );
};
